















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BaseTable extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public columns;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public tableBtn;
  @Prop({
    type: Boolean,
    default: false,
  })
  public loading;
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  public data;
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  public pageSize;
  @Prop({
    type: Function,
    default: () => {
      return {};
    },
  })
  public changepage;
  @Prop({
    type: Function,
    default: () => {
      return {};
    },
  })
  public editChange;
  @Prop({
    type: Function,
    default: () => {
      return {};
    },
  })
  public sizeChange;
}
